export enum OriginEnum {
  CONTACT_BUTTON,
  SHARE_BUTTON
}